export const sizing = {
  xs: '0.4rem',
  sm: '0.8rem',
  md: '1.2rem',
  lg: '1.6rem',
  xl: '2.4rem',
  '2xl': '3.2rem',
  '3xl': '4rem',
  '4xl': '4.8rem',
};

export const colors = {
  main: 'var(--main)',
  'main-dark': 'var(--main-dark)',
  'main-light': 'var(--main-light)',
  mask: 'var(--mask)',
  bg: 'var(--bg-color)',
  light: 'var(--light)',
  danger: 'var(--danger)',
  text: 'var(--text-color)',
  grey: 'var(--text-grey)',
  active: 'var(--active-color)',
  header: 'var(--header-color)',
  textLight: 'var(--text-light)',
  'light-grey': 'var(--text-light-grey)',
  content: 'var(--content-color)',
} as const;

export const fontSize = {
  tiny: ['1.2rem', '1.6rem'],
  small: ['1.4rem', '1.8rem'],
  medium: ['1.6rem', '2.4rem'],
  big: ['1.8rem', '2.2rem'],
  title: ['2rem', '2.3rem'],
  section: ['2.4rem', '2.4rem'],
  heading: ['2.8rem', '2.8rem'],
  huge: ['3.6rem', '4rem'],
} as const;
